import { useLingui } from "@lingui/react/macro";
import { ChefAvatar } from "@/components/ui/chef-avatar";

/** The chef on a recipe: initials and name, or "Unassigned". */
export function ChefLabel({ name }: { name: string | null }) {
  const { t } = useLingui();
  return (
    <span className="inline-flex items-center gap-2 text-sm font-medium text-(--color-text-primary)">
      <ChefAvatar name={name} />
      {name ?? t`Unassigned`}
    </span>
  );
}
